module.exports = __webpack_public_path__ + "static/yum_hero_bg-d420e404d44cc74e2d9ce317cef384c4.png";